import { html as e, when as t } from "@microsoft/fast-element";
const r = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.75 9L12 15.75L5.25 9H18.75Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, n = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.75 9L12 15.75L5.25 9H18.75Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, l = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.625 7.5L10 13.125L4.375 7.5H15.625Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, s = e`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
    <path
      d="M12.5 6L8 10.5L3.5 6H12.5Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
`, w = e`
  ${t((o) => o._type === "outline", n)}
  ${t((o) => o._type === "solid", r)}
  ${t((o) => o._type === "mini", l)}
  ${t((o) => o._type === "micro", s)}
`;
export {
  w as arrowHeadDownTemplate
};
